<div class="flex flex-col rounded shadow bg-slate-100">
    <div class="flex flex-row p-2 gap-2 items-center text-sm shadow">
        @if (exportStatus.isPending) {
            <div class="p-1 text-white rounded shadow-sm w-[8ch] text-center" [style.background]="ColorPending">Pending</div>
        } @else {
            @if (exportStatus.isSuccess) {
                <div class="p-1 text-white rounded shadow-sm w-[8ch] text-center" [style.background]="ColorSuccess">Success</div>
            } @else {
                <div class="p-1 text-white rounded shadow-sm w-[8ch] text-center" [style.background]="ColorFailed">Failed</div>
            }
        }
        <div class="grow" title="{{ exportStatus.startedAt }}">{{ exportStatus.startedAt | datetime:true }}</div>
        <button (click)="onShowDetailsClicked()" class="hover:text-ponder-linkhover">
            @if (!showDetails) {
                See Details
            } @else {
                Hide Details
            }
        </button>
    </div>
    @if (showDetails && !exportStatus.isPending) {
        <div class="bg-slate-50 p-2 rounded-b flex flex-col gap-2 text-sm">
            @if (result) {
                @if (!isExpired) {
                    <a target="_blank" href="{{ result.artifactUrl }}"
                        class="flex flex-row items-center gap-2 align-middle justify-center text-sm p-2 bg-white rounded shadow-sm stroke-ponder-light hover:text-ponder-link hover:stroke-ponder-link hover:cursor-pointer border border-transparent hover:border-ponder-link">
                        <svg class="size-4 fill-none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="1.5">
                            <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="downloadSvgIcon" />
                        </svg>
                        <span>Download</span>
                    </a>
                } @else {
                    <div class="flex flex-row items-center gap-2 align-middle justify-center text-sm p-2 bg-white text-slate-400 stroke-slate-400">
                        <svg class="size-4 fill-none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="1.5">
                            <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="downloadSvgIcon" />
                        </svg>
                        <span>Expired</span>
                    </div>
                }
                <div>
                    <span class="font-bold">Expires:</span> {{ result.artifactExpiresAt | datetime:true }}
                </div>
                <div class="flex flex-row gap-4">
                    <div>
                        <span class="font-bold">Game:</span> {{ result.game }}
                    </div>
                    <div>
                        <span class="font-bold">Format:</span> {{ exportStatus.result!.collectionType }}
                    </div>
                    <div>
                        <span class="font-bold">Success:</span> {{ result.successCount }}
                    </div>
                    <div>
                        <span class="font-bold">Failures:</span> {{ result.failureCount }}
                    </div>
                </div>
                @if (result.failures && result.failures.length) {
                    <div class="flex flex-row gap-2">
                        <div class="font-bold pt-2">
                            Failure Details
                        </div>
                        <div class="flex flex-col gap-1 bg-white rounded-sm p-2 grow shadow-sm">
                            @for (failure of result.failures ; track failure) {
                                <div>{{ failure }}</div>
                            }
                        </div>
                    </div>
                }
            }
        </div>
    }
</div>